import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=c79ae6c8&scoped=true&"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts&"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79ae6c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
